import { marked } from 'marked';
import type { AppState, Actions } from '../state';

export function renderReview(root: HTMLElement, state: AppState, actions: Actions): void {
  const t = state.transcription;
  if (!t) {
    root.innerHTML = '<p>No transcription to review.</p>';
    return;
  }

  const isNocturne = state.settings.deliveryMode === 'nocturne-tray';
  const confirmLabel = isNocturne
    ? (state.isUploading ? 'Sending…' : 'Confirm & send')
    : (state.isUploading ? 'Saving…' : 'Download .md');

  root.innerHTML = `
    <div class="screen screen-review">
      <header class="topbar">
        <button class="btn btn-ghost" data-action="retake">← Retake</button>
        <h1>Review</h1>
      </header>

      <label class="field">
        <span>Title</span>
        <input data-field="title" value="${esc(state.editingTitle)}" />
      </label>

      ${
        isNocturne
          ? `
      <label class="field">
        <span>Tags (comma-separated)</span>
        <input data-field="tags" value="${esc(state.editingTagsText)}" />
      </label>

      <label class="field">
        <span>Book</span>
        <select data-field="book">
          ${state.settings.books
            .filter((b) => b.length > 0)
            .map(
              (b) =>
                `<option value="${esc(b)}"${b === state.editingBook ? ' selected' : ''}>${esc(b)}</option>`,
            )
            .join('')}
        </select>
      </label>`
          : ''
      }

      <section class="preview">
        <div class="preview-toolbar">
          <span class="preview-label">Transcription</span>
          <label class="toggle">
            <input type="checkbox" data-action="toggle-raw" />
            <span>Raw</span>
          </label>
        </div>
        <div class="preview-rendered" data-view="rendered">${renderMarkdown(t.body)}</div>
        <pre class="preview-raw" data-view="raw" hidden>${esc(t.body)}</pre>
      </section>

      ${state.errorMessage
        ? `<div class="error-banner">${esc(state.errorMessage)}</div>`
        : ''}

      <button class="btn btn-primary btn-block" data-action="confirm" ${state.isUploading ? 'disabled' : ''}>
        ${confirmLabel}
      </button>
    </div>
  `;

  root.querySelector<HTMLInputElement>('[data-field="title"]')!.addEventListener('input', (e) => {
    state.editingTitle = (e.target as HTMLInputElement).value;
  });
  const tagsInput = root.querySelector<HTMLInputElement>('[data-field="tags"]');
  tagsInput?.addEventListener('input', (e) => {
    state.editingTagsText = (e.target as HTMLInputElement).value;
  });
  const bookSelect = root.querySelector<HTMLSelectElement>('[data-field="book"]');
  bookSelect?.addEventListener('change', (e) => {
    state.editingBook = (e.target as HTMLSelectElement).value;
  });
  root.querySelector<HTMLButtonElement>('[data-action="retake"]')!.addEventListener('click', () => {
    actions.retake();
  });
  root.querySelector<HTMLInputElement>('[data-action="toggle-raw"]')!.addEventListener('change', (e) => {
    const raw = (e.target as HTMLInputElement).checked;
    root.querySelector<HTMLElement>('[data-view="rendered"]')!.hidden = raw;
    root.querySelector<HTMLElement>('[data-view="raw"]')!.hidden = !raw;
  });
  root.querySelector<HTMLButtonElement>('[data-action="confirm"]')!.addEventListener('click', () => {
    void actions.confirmUpload();
  });
}

function renderMarkdown(body: string): string {
  return marked.parse(body, { async: false }) as string;
}

function esc(value: string): string {
  return value.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}
